import { render, staticRenderFns } from "./IssueForm.vue?vue&type=template&id=5c0ae2c8&scoped=true"
import script from "./IssueForm.vue?vue&type=script&lang=js"
export * from "./IssueForm.vue?vue&type=script&lang=js"
import style0 from "./IssueForm.vue?vue&type=style&index=0&id=5c0ae2c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0ae2c8",
  null
  
)

export default component.exports